/* eslint-disable react/no-multi-comp */
import React, { Fragment } from "react"
import { css, useSassUnitValues } from "@jsUtils"
import { CONSTANTS } from "@data"
import { Headline, GridLines, Eyebrow, CTA, Analytics } from "@shared"
import { PageSection } from "../PageSection"

// eslint-disable-next-line no-unused-vars
import Styles from "./techSpecs.module.scss"

const { BREAKPOINTS } = CONSTANTS
const MOBILE_BREAKPOINT = useSassUnitValues(BREAKPOINTS.DESKTOP)
/**
 * Tech Spec Section of the Exo-Works page
 * Output some of the tech specs (selected items)
 * @param {object} props - React props
 */
const TechSpecs = props => {
  const { theme, color, techSpecs, detailPage } = props
  const [ready, setReady] = React.useState(false)
  const [mobileLayout, setMobileLayout] = React.useState(false)
  const [currentSpec, setCurrentSpec] = React.useState(0)

  const SpecButton = Analytics("button")

  const specs = techSpecs.map((techSpec, index) => {
    return (
      <Fragment key={`tech-spec-${techSpec.id}`}>
        {mobileLayout ? (
          <div className={Styles.mobileSpecs}>
            <Headline className={Styles.mobileTitle} color={color} size={4}>
              {techSpec.title}
            </Headline>
            <div
              className={Styles.mobileDetails}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: techSpecs[index].description }}
            />
          </div>
        ) : (
          <SpecButton
            ascope="LISTS"
            adata={{
              content: techSpec.title
            }}
            key={`tech-spec-${techSpec.id}`}
            type="button"
            className={css(Styles.techSpecTitle, index === currentSpec && Styles.active)}
            onClick={() => {
              setCurrentSpec(index)
            }}
          >
            {techSpec.title}
          </SpecButton>
        )}
      </Fragment>
    )
  })

  const onResize = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT && !mobileLayout) {
      setMobileLayout(true)
    } else if (window.innerWidth >= MOBILE_BREAKPOINT && mobileLayout) {
      setMobileLayout(false)
    }
  }

  React.useEffect(() => {
    onResize()
    window.addEventListener("resize", onResize)
    return () => {
      window.removeEventListener("resize", onResize)
    }
  })

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.wrapper}>
        <div className={Styles.header}>
          <Eyebrow className={Styles.eyebrow} color={color}>
            Tech Specs
          </Eyebrow>
          <Headline size={2} className={Styles.headline}>
            We know that the details matter.
          </Headline>
        </div>
        <div className={Styles.content}>
          <div className={Styles.specs}>
            {specs}
            <CTA
              ascope="CTAS"
              adata="MISC.TECHSPECS"
              ready={ready}
              className={Styles.cta}
              color={color}
              to={`${detailPage}`}
            >
              View All
            </CTA>
          </div>
          <div className={Styles.details}>
            <div
              className={Styles.detailsContent}
              key={`spec-details-${currentSpec}`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: techSpecs[currentSpec].description }}
            />
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default TechSpecs
